import React, { useEffect, useMemo, useState } from 'react'
import { ChatCommonPage } from '../../../commonPage'

import { PiDotsThreeOutlineVertical, PiFolderOpen, PiThumbsUp } from 'react-icons/pi'
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor } from '../../../redux/actions';
import { Badges } from '../../../components';
import { useAlert } from '../../../contexts';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const RequestedChats = ({ loginData }) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const [showModal2, setShowModal2] = useState(false);
    const [credentials] = useState({
        doctorGuid: loginData.userGuid,
        currency: loginData.currencyCode,
        languageId: loginData.languageId,
        RequestTimeZone: loginData.timeZoneId,
    });
    useEffect(() => {
        dispatch(actionDoctor.getChatAppointmentByDoctor(credentials));
    }, [dispatch, credentials]);
    const getChatAppointmentByDoctorData = useSelector(
        (state) => state.doctor.getChatAppointmentByDoctorData?.data
    );
    const filteredChats = useMemo(() =>
        getChatAppointmentByDoctorData?.result?.filter((item) => item.status === 1) || [],
        [getChatAppointmentByDoctorData]
    );
    // const getBookedChatDetails = (appointment, openModal) => {
    //     const credentials = {
    //         UserTimeZone: loginData.timeZoneId,
    //         UserCurrency: loginData.currencyCode,
    //         appointmentGuid: appointment.appointmentGuid,
    //         LanguageId: loginData.languageId,
    //     };

    //     dispatch(
    //         actionPatient.getBookedChatDetails(credentials, (error, response) => {
    //             if (error) {
    //                 if (error.data) {
    //                     if (error.data.statusCode === 400) {
    //                         if (error.data.error && error.data.error.ValidationErrors) {
    //                             error.data.error.ValidationErrors.forEach((validationError) => {
    //                                 console.error(
    //                                     `${t("Field")}: ${validationError.Field} - ${t(
    //                                         "Message"
    //                                     )}: ${validationError.Message}`
    //                                 );

    //                                 showAlert(
    //                                     "danger",
    //                                     validationError.Message,
    //                                     `${t("Error")} : ${validationError.Field}`
    //                                 );
    //                             });
    //                         } else {
    //                             showAlert(
    //                                 "danger",
    //                                 t("Invalid_credentials"),
    //                                 `${t("Error")} !`
    //                             );
    //                         }
    //                     } else {
    //                         showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
    //                     }
    //                 }
    //             } else if (response) {
    //                 if (response.status === 200) {
    //                     if (openModal) {
    //                         setShowModal2(true);
    //                     }
    //                 }
    //             }
    //         })
    //     );
    // };



    const onSearchClick = () => {

    }


    // onClick={() =>
    //     }

    const updateChat = (chat) => {

        console.log("chat", chat);
        const credentials1 = {
            appointmentGuid: chat.appointmentGuid,
            DoctorGuid: chat.doctorGuid,
            Status: 2,
            IsChatAccepted: true,
            PatientGuid: chat.patientGuid,
            ContinueChatStatus: 1
        }
        dispatch(actionDoctor.postUpdateChatAppointment(credentials1, (error, response) => {
            if (error) {
                if (error.data) {
                    if (error.data.statusCode === 400) {
                        if (error.data.error && error.data.error.ValidationErrors) {
                            error.data.error.ValidationErrors.forEach(
                                (validationError) => {
                                    console.error(
                                        `${t("Field")}: ${validationError.Field} - ${t(
                                            "Message"
                                        )}: ${validationError.Message}`
                                    );

                                    showAlert(
                                        "danger",
                                        validationError.Message,
                                        `${t("Error")} : ${validationError.Field}`
                                    );
                                }
                            );
                        } else {
                            if (error.data.message) {
                                showAlert(
                                    "danger",
                                    error.data.message,
                                    `${t("Error")} !`
                                );
                            } else {
                                showAlert(
                                    "danger",
                                    `${t("Invalid_credentials")}`,
                                    `${t("Error")} !`
                                );
                            }

                        }
                    } else {
                        showAlert(
                            "danger",
                            `${t("unexpected_error")}``${t("Error")} !`
                        );
                    }
                }
            } else if (response) {
                if (response.status === 200) {
                    showAlert("secondary", t("chatPage.chat_end_successfully"), "Info !");
                    navigate(`/doctor/chat-with-patient/${chat?.appointmentGuid}`,
                        { state: { chat } })

                }
            }
        }));



    }
    return (

        <>
            <ChatCommonPage
                pageHeading={t("chatPage.requested.pageHeading")}
                loginData={loginData}
                chatTableHeading={t("chatPage.requested.chatTableHeading")}
                chatTableColumns={[`${t("booking_id")}`, `${t("patient_name")}`, `${t("patient_details")}`, `${t("time_&_date")}`, `${t("status")}`, loginData?.currencyCode, `${t("start_chat")}`]}
                chatTableData={filteredChats?.map((chat, index) => ({
                    [t("booking_id")]: chat.chatBookingId,

                    [t("patient_name")]: (
                        <div className="d-flex align-items-center">
                            <Badges.Badge1
                                text={chat.externalUser ? "G" : "E"}
                                className={`ge-badge ${chat.externalUser ? "g-badge" : "e-badge"
                                    }`}
                            />{" "}
                            {chat.patientName}
                        </div>
                    ),

                    // 'Medical specialty': chat.physicianServices?.map((service, index) => (<div key={index}>{service}</div>)),
                    [t("patient_details")]: (
                        <div className="editBlkIcon">
                            <PiFolderOpen className="editIcon"
                            // onClick={() => getBookedChatDetails(chat, true)}
                            />
                        </div>
                    ),
                    [t("time_&_date")]: (
                        <>
                            <div>
                                {new Date(
                                    chat.appointmentDateTime
                                ).toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                })}
                            </div>
                            <div>
                                {new Date(chat.appointmentDateTime)
                                    .toLocaleDateString("en-GB")
                                    .replace(/\//g, " - ")}
                            </div>
                        </>
                    ),
                    [t("status")]: chat.status === 1 ? "Requested" : "",
                    [loginData?.currencyCode]: chat.chatFees,
                    [t("start_chat")]: (
                        <div className="editBlkIcon">
                            <PiThumbsUp
                                className="editIcon"
                                onClick={() => updateChat(chat)}

                            />
                        </div>
                    ),

                }))}
                className="doctor-chats-ongoing"
                onSearchClick={onSearchClick}
            />


        </>


    )
}

export default RequestedChats
